import {Injectable} from '@angular/core';
import {IService} from '../IService';
import {PromotionCampaignTypeModel} from '../../models/promotion-campaign-type.model';
import {HttpClientService} from '../httpClient/httpclient.service';

@Injectable()
export class PromotionCampaignTypeService extends IService<PromotionCampaignTypeModel> {

  constructor(
    http: HttpClientService
  ) {
    super(http, 'koncentro-promo', 'campaign-type')
  }

}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-campaign-type.service.ts